import React from "react";
import Header from "./header";
import HordePageFooter from "./footer";

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

/**
 * Wrapper component for navigation elements.
 * This component handles the visibility of navigation elements based on screen size.
 */
const NavigationWrapper = ({ children }: Props) => {
  return (
    <>
      {/* Top navigation bar */}
      <Header />

      {/* Content */}
      <main>{children}</main>

      {/* Footer */}
      <HordePageFooter />
    </>
  );
};

export default NavigationWrapper;
